import { Action, createAction, props } from '@ngrx/store'
import { VolunteerProfileEntity } from './profiles.models'
import { HttpErrorResponse } from '@angular/common/http'

export const openGuestSelect = createAction(
  '[Profiles] Open Guest Select',
  props<{ skipProfileCheck?: boolean; onSelectGuestActions?: Action[] }>(),
)

export const loadProfilesVolunteer = createAction(
  '[Profiles/API] Load Profiles Volunteer',
  (limit = 10, offset = 0, search?: string) => ({ limit, offset, search }),
)

export const loadProfilesVolunteerSuccess = createAction(
  '[Profiles/API] Load Profiles Volunteer Success',
  props<{ profiles: VolunteerProfileEntity[]; count: number }>(),
)

export const loadProfilesVolunteerFailure = createAction(
  '[Profiles/API] Load Profiles Volunteer Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const openRegisterGuestDialog = createAction(
  '[Profiles] Open Register Guest dialog',
  props<{ onSelectGuestActions?: Action[] }>(),
)

export const checkVolunteerVerification = createAction(
  '[Profiles] Check Volunteer Verification',
  props<{ onSelectGuestActions?: Action[] }>(),
)

export const clearProfiles = createAction('[Profiles] Clear Profiles')
